module.exports = __webpack_public_path__ + "img/module6.b543b53.png";